import { Component, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../environments/environment';

import { BffUserService } from '@canvas/four-r-digital';

@Component({
  templateUrl: './invalid-permissions.component.html',
  styleUrls: ['./invalid-permissions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InvalidPermissionsComponent {
  constructor(private readonly bffService: BffUserService) {}

  logout(): void {
    const { baseHRef } = environment;
    this.bffService.logout(baseHRef);
  }
}
